module.exports = __webpack_public_path__ + "static/img/4.7d810b53.png";